import React, { useEffect } from 'react';
import PendingApprovalStyles from "./PendingApproval.module.css";
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import NoteAltOutlinedIcon from '@mui/icons-material/NoteAltOutlined';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FilterListIcon from '@mui/icons-material/FilterList';
import Modal from '@mui/material/Modal';
import { Link } from 'react-router-dom';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';

// import this for redux read write
import { useSelector, useDispatch } from 'react-redux';
import { setNotifications } from '../../state/GlobalState';
import { setNotificationCount } from '../../state/GlobalState';
import { fetchNotifications } from '../../state/GlobalState';



function createData(id, name, email, number, date, job) {
    return { id, name, email, number, date, job };
}

const rows = [];

const PendingApproval = () => {

    
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 480,
        bgcolor: 'background.paper',
        border: '2px solid gray',
        boxShadow: '2px 2px 10px 2px gray',
        borderRadius: '5px',
        p: 4,
    };

    //   const [style, setStyle] = useState(null);
//   const [listStyle, setListStyle] = useState(null);
//   const [selectedData, setSelectedData] = useState(null);

  const [selectedData, setSelectedData] = useState({})
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [view, setView] = useState(false)
  const handleView = (row) => {
      setView(true)
      console.log(row)
      setSelectedData(row)

  }
  const handleViewClose = () => setView(false)
  

  const name=useSelector((state)=>state.globalData.name);
  const count=useSelector((state)=>state.globalData.notificationCount);
  const dispatch =  useDispatch()


    const [data, setData] = useState([])

    const getApplicantData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_STEELADMIN}/partnerUs/getAll`
            )
            setData(res.data)
            // console.error("helloss")
            // console.log(res.data)
            // console.log(res.data[0].jobrole[0].resume[0].userAppForm.applicantName)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getApplicantData();

    }, [])




    const [jobRole, setJobRole] = React.useState("");

    const handleJobRoles = (event) => {
        setJobRole(event.target.value);
    };

    // const [open, setOpen] = useState(false);
    // const handleOpen = () => setOpen(true);
    // const handleClose = () => setOpen(false);

    const [query, setQuery] = useState("");

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const deleteApplicantbyId = async (partnerId) => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_STEELADMIN}/partnerUs/deletePartnerFormById/${partnerId}`
            )
                console.log( res)
              // this is the snipte for the notification
           dispatch(fetchNotifications())

           dispatch(setNotificationCount({
            count:count+1,
           }))
                 
                 
               //   uptill here 
  
            alert('Delete Successful!')
            // window.location.reload()
            
        } catch (error) {
            console.log(error);
        }
        getApplicantData();
    }

    const filteredData = [];




      console.log(filteredData)


    return (
        <>
            <Card sx={{ maxWidth:'95%', border: 'none', outline:'none',boxShadow:'none', mt:'3%' }}>
                <CardContent>
                    <Paper className={PendingApprovalStyles.myboder}>
                        <TableContainer sx={{ maxHeight: 650 }}>
                            <div className={PendingApprovalStyles.jobApplicantListBox1}>
                                <Box className={PendingApprovalStyles.Box1}>
                                    <Typography variant='h5' 
                                    sx={{
                                        fontWeight:'500',
                                        fontSize:'20px',
                                        lineHeight:'24px',
                                        color:'#121926'
                                        }}>Pending Approval</Typography>
                                    <Typography variant='h6'>12 entries</Typography>
                                </Box>
                                <Box className={PendingApprovalStyles.Box1} sx={{display:'flex'}}>
                                    <Typography variant='h5' 
                                    sx={{
                                        fontWeight:'500',
                                        fontSize:'20px',
                                        lineHeight:'24px',
                                        color:'#121926',
                                        display:'flex'
                                        }}>Filter by</Typography>
                                    <Typography variant='h6'>Job Roles</Typography>
                                </Box>
                            </div>
                            <div className={PendingApprovalStyles.jobApplicantListBox2}>
        
                                {/* <Box className={PendingApprovalStyles.Box2}>
                                    Filter by
                                    <FormControl sx={{ m: 1, width: '200px' }}>
                                        <Select
                                            value={jobRole}
                                            // filter={job.careerJobRoleName}
                                            onChange={handleJobRoles}
                                            displayEmpty
                                            inputProps={{ "aria-label": "Without label" }}
                                            style={{height:'5vh'}}
                                        >

                                            <MenuItem value="">All Roles</MenuItem>
                                            <MenuItem value='Javascript'>Javascript</MenuItem>
                                            <MenuItem value='Technical'>Technical</MenuItem>
                                            <MenuItem value='React JS Developer'>React JS Developer</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box> */}
                            </div>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow className={PendingApprovalStyles.Mainhead}>
                                        <TableCell className={PendingApprovalStyles.Tablehead}>Name</TableCell>
                                        <TableCell className={PendingApprovalStyles.Tablehead}>Email</TableCell>
                                        <TableCell className={PendingApprovalStyles.Tablehead}>Company</TableCell>
                                        <TableCell className={PendingApprovalStyles.Tablehead}>Phone Number</TableCell>
                                        {/* <TableCell className={PendingApprovalStyles.Tablehead}>Registered</TableCell> */}
                                        <TableCell className={PendingApprovalStyles.Tablehead}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {

                                        data
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row) => {
                                                return (
                                                    <TableRow className={PendingApprovalStyles.MainRow} hover role="checkbox" tabIndex={-1} key={row.partnerId} >
                                                        <TableCell className={PendingApprovalStyles.Tablerow1}> {row.partnerName}<Box className={PendingApprovalStyles.Email}></Box></TableCell>
                                                        <TableCell className={PendingApprovalStyles.Tablerow}>
                                                        {row.email}
                                                        </TableCell>
                                                        <TableCell className={PendingApprovalStyles.Tablerow1}> {row.companyName}<Box className={PendingApprovalStyles.Email}>{row.companyWebsite}</Box></TableCell>
                                                        {/* <TableCell className={PendingApprovalStyles.Tablerow}>{row.companyName} </TableCell> */}
                                                        <TableCell className={PendingApprovalStyles.Tablerow}>
                                                            {row.rolesDetails}
                                                        </TableCell>
                                                        <TableCell className={PendingApprovalStyles.Tablerow}>
                                                            {row.dateCreated}
                                                        </TableCell>
                                                        <TableCell className={PendingApprovalStyles.Tablerow2}>
                                                            {/* <Link
                                                               to={ `/partnership/${row?.partnerId}`}
                                                               state={{row:row}}
                                                            >
                                                                */}
                                                               
                                                                {/* <VisibilityOutlinedIcon className={PendingApprovalStyles.Tableicon} style={{ marginRight: '10%' }} onClick={() => handleView(row)} />

                                                              
                                                          
                                                            <Link disableRipple onClick={() => deleteApplicantbyId(row.partnerId)}>
                                                                <DeleteForeverOutlinedIcon style={{marginLeft:'10%'}} className={PendingApprovalStyles.Tableicon} />
                                                            </Link> */}
                                                            <Button variant='outline'>View</Button>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                  
                                   }


                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            style={{paddingTop:'2%'}}

                        />
                    </Paper>
                </CardContent>
            </Card>
        </>
    )
}

export default PendingApproval